import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { ArrowLeft, ArrowRight } from 'app/components/Icons'
import { rgba } from 'emotion-rgba'
import React, { memo } from 'react'

export interface Props {
  direction?: 'L' | 'R'
  disabled?: boolean
  onClick?: (e: any) => void
  onKeyDown?: any
  role?: string
  tabIndex?: number
  variant?: Variant
}

export const Arrow = memo(function Arrow({
  direction = 'L',
  disabled,
  onClick,
  onKeyDown,
  role = 'button',
  tabIndex = 0,
  variant = 'default',
}: Props) {
  return (
    <Container
      className={disabled ? 'disabled' : undefined}
      onClick={onClick}
      onKeyDown={onKeyDown}
      role={role}
      tabIndex={tabIndex}
      variant={variant}
    >
      {direction === 'L' ? <ArrowLeft /> : <ArrowRight />}
    </Container>
  )
})

const Container = styled.div<ContainerProps>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 4rem;
  height: 4rem;
  background: ${({ theme }) => theme.colors.variants.neutralLight3};
  border-radius: 50%;
  cursor: pointer;
  &:focus,
  &:focus-visible,
  &:hover {
    svg {
      opacity: 0.5;
    }
  }
  &.disabled {
    pointer-events: none;
  }

  svg {
    width: auto;
    height: 1rem;
    fill: ${({ theme }) => theme.colors.variants.primaryDark};
    transition: 0.3s ease-out;
  }

  ${({ theme, variant }) => {
    switch (variant) {
      case 'custom':
        return css`
          background: none;
          border: 0.0625rem solid
            ${rgba(theme.colors.variants.primaryDark, 0.2)};
        `
      case 'simple':
        return css`
          width: 1rem;
          height: 1rem;
          background: none;
          border-radius: 0;

          svg {
            fill: ${theme.colors.variants.neutralLight1};
          }
        `
    }
  }}
`

interface ContainerProps {
  variant: Variant
}

export type Variant = 'default' | 'custom' | 'simple'
